import { useRequest } from 'features/request/useRequest';
import { formatDateToLocale } from 'utils';

import { useMemo } from 'react';

import { workOrderVersionsGql } from '../../WorkOrder/workOrderQueries';

export const useTitleStructureVersion = (workOrderId: number, workOrderVersionId: number) => {
    const variables = useMemo(
        () => ({
            workOrderId,
        }),
        [workOrderId],
    );

    const [workOrderVersionsData] = useRequest({
        requestId: 'workOrderVersions',
        query: workOrderVersionsGql,
        variables,
        withEffect: true,
    });

    const currentVersion = workOrderVersionsData?.uerWorkOrderVersions?.find(
        (item) => item.workOrderVersionItem.id === workOrderVersionId,
    )?.workOrderVersionItem;

    const titleStructureVersion = `Структура Наряд-Заказа №${currentVersion?.internalNumber} от ${formatDateToLocale(
        currentVersion?.signingDate,
    )}`;

    return { titleStructureVersion };
};
